import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const CreateOrgOnboardingSurvey = async ({ clientId }: { clientId: string }): Promise<ISurveyFull | null> => {
    try {
        const response = await Requester<ISurveyFull>({
            path: `organizations/${clientId}/onboarding`,
            method: 'POST'
        });

        return Object.hasOwn(response, '_id') ? (response as ISurveyFull) : null;
    } catch (e) {
        console.error('Create new onboarding survey request failed');
        return Promise.reject(e);
    }
};
